import React from 'react'

import Button from '~/components/Button'
import Icon from '~/components/Icon'

const TryIt = ({ text = 'Try it now' }) => (
  <Button size="big" to="/download">
    {text} <Icon name="github" />
  </Button>
)

export default TryIt



// WEBPACK FOOTER //
// ./src/components/pages/TryIt.js